export const GOOGLE_TTS_API_PREFIX = `https://texttospeech.googleapis.com/v1beta1/text:synthesize`;
export const SPEAK_TAG_WRAPPER = '<speak>';
export const SPEAK_CLOSE_TAG_WRAPPER = '</speak>';
export const MP3_ENCODING_IDENTIFIER = 'MP3';
export const POST_REQUEST_IDENTIFIER = 'POST';
export const GOOGLE_TTS_REQUEST_CONTENT_TYPE = 'application/json; charset=UTF-8';
export const AUDIO_ELEMENT_IDENTIFIER = 'audio';
export const SOURCE_OPEN_EVENT_IDENTIFIER = 'sourceopen';
export const MPEG_SOURCE_BUFFER_TYPE_IDENTIFIER = 'audio/mpeg';
export const UPDATEEND_EVENT_IDENTIFIER = 'updateend';
export const GOOGLE_VOICE_ID_SEPERATORS_CHARACTER = '-';
export const THUMBNAIL_IMG_SIZE = 300;
export const CANVAS_WIDTH = 1920;
export const CANVAS_HEIGHT = 1080;
export const DRAFT_TEXT_PLACEHOLDER = 'DRAFT_TEXT_PLACEHOLDER';
